export default "__VITE_ASSET__18619821__"